import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';

function VoucherDetail() {
    useAuthGuard();

    return (
        <Layout>

            Voucher

        </Layout>
    );
}

export default VoucherDetail;
